export const RENDER_TYPE = {
  ARTICLES_GRID: 'articles-grid',
  ARTICLES_GRID_CAROUSEL: 'articles-grid-carousel',
  VIDEOS: 'videos',
  AD_UNIT: 'ad-leaderc',
  RESEARCH_BY_TYPE: 'research-by-type',
  EV_INCENTIVES: 'ev-incentives',
  EV_MPG: 'ev-mpg',
  EV_RANGE_LEADER_BOARD: 'ev-range-leader-board',
  COMPARATOR_TABLE: 'comparator-table',
  HTML: 'html',
  TOP_RATED: 'top-rated',
};
